import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { DateBox, SelectBox, TextArea, CheckBox} from 'devextreme-react';
import { TerminationsTemplateTypes } from "../../../../../Constantes/documentataionRequestTypes";
import { useDispatch, useSelector } from "react-redux";
import {  deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors";
import dayjs from "dayjs";
import { selectProvincesLoading } from "../../../../../redux/provinces/selectors";
import { getFactoryProvinces, getTerminationsFactoryProvinces } from "../../../../../redux/factoryProvinces/thunks";
import { selectFactoryProvinces, selectFactoryTerminationProvinces } from "../../../../../redux/factoryProvinces/selectors";
import { selectFactoryCities, selectFactoryCitiesLoading, selectFactoryTerminationCities, selectFactoryTerminationCitiesLoading } from "../../../../../redux/factoryCities/selectors";
import { getFactoryCities, getFactoryTerminationCities } from "../../../../../redux/factoryCities/thunks";
import { factoryActive } from "../../../../../Constantes/factoryActive";
import { selectCurrentCase } from "../../../../../redux/currentCase/selectors";
import { convertToLocalTime } from "../../../../../commonFunctions/commonFunctions";
import { openModal } from "../../../../../redux/modal/modalSlice";

function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function TerminationsRequestForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const typesLoading = useSelector(selectTaxonomyTemplatesLoading)
const [type, setType] = useState(dataForm?.templateCode)
const hourRange=["8 - 11 h","11 - 15 h","15 - 18 h"];
const mtrTypes = ["Pre Entrega", "Renting Flexible"];
const terminationProvinces = useSelector(selectFactoryTerminationProvinces);
const allProvinces = useSelector(selectFactoryProvinces);
const provincesLoading = useSelector(selectProvincesLoading);
const terminationCities= useSelector(selectFactoryTerminationCities)
const allCitiesLoading = useSelector(selectFactoryCitiesLoading)
const terminationCitiesLoading = useSelector(selectFactoryTerminationCitiesLoading)
const allCities = useSelector(selectFactoryCities);
const currentCase = useSelector(selectCurrentCase);
const [minimunDate, setMinimunDate] = useState();
const provinces = dataForm?.subType === "renting_own_insurance_mtr" ? allProvinces : terminationProvinces;
const cities = dataForm?.subType === "renting_own_insurance_mtr" ? allCities : terminationCities;
const citiesLoading = allCitiesLoading === "loading" || terminationCitiesLoading === "loading";

useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))   
    setMinimunDate(calculateMinimunDate());
},[])

useEffect(()=>{
    if(factoryActive){
        dispatch(getTerminationsFactoryProvinces());
        dispatch(getFactoryProvinces());
    }     
},[])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    }
    if(type === TerminationsTemplateTypes.RENTING_OTHER_INSURANCE){
        changeMtr(false)
    }
},[type, types])

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}
function changeDateFormat(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function changeDateTimeFormat(field, date){
    const stringDate = dayjs(date).format()
    onChange(field,stringDate)
}

function changeMtr(value){
    if(value){
        onChange("subType", `${dataForm.templateCode}_mtr`)
    } else {
        onChange("subType", null)
    }
    onChange("mtr", value)
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

useEffect(()=>{
    if(factoryActive){
    if(dataForm?.province){
        const provinceId = provinces.find(factoryProvince=> factoryProvince.description === dataForm.province).id;   
        if(dataForm?.subType === "renting_own_insurance_mtr"){
            onChange("city", null)
            dispatch(getFactoryCities({query:`?provinceId=${provinceId}`}))
        } else {
            onChange("city", null)
            dispatch(getFactoryTerminationCities({query: `?provinceCode=${provinceId}`}));
        }
       
    }
    }   
},[dataForm?.province, dataForm?.subType])

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

function calculateMinimunDate(){
    let caseCreationDate = currentCase?.caseId !== 0 ? currentCase?.creationDate : new Date(); // los casos que aún no se han creado en bbdd no tienen fecha de creación, usamos la actual
    const dayOfWeek = new Date(caseCreationDate).getDay();
    const minimunTimeInHours = dayOfWeek > 2 ? 120 : dayOfWeek === 0 ? 96 : 72;
    let minimunDate = dayjs(convertToLocalTime(caseCreationDate)).add(minimunTimeInHours, "hour").toDate()
    return minimunDate
}

function changeDateTime(field,value){
    let isError = true;
    if(value){
        const isBeforeMinimunDate = dayjs(value).isBefore(minimunDate)

        if(isBeforeMinimunDate){
            changeDateTimeFormat(field, minimunDate)
        } else {
            changeDateTimeFormat(field, value)
            isError = dayjs(value).isSame(minimunDate)? true: false
        }       
    }
    if(isError){
        dispatch(openModal({type: "warning", message: `La fecha mínima es ${dayjs(minimunDate).format("DD/MM/YYYY, HH:mm")}`}))
        changeDateTimeFormat(field, minimunDate)
    }
}

function changeDate(field,value, isPreselect = false){
    let isError = true;
    if(value){
        const isBeforeMinimunDate = dayjs(value).isBefore(new Date(minimunDate.toDateString()))
        if(isBeforeMinimunDate){
            changeDateFormat(field, minimunDate)
        } else {
            changeDateFormat(field, value)
            isError = dayjs(value).isSame(minimunDate) && !isPreselect? true: false
        }
    }
    if(isError){
        dispatch(openModal({type: "warning", message: `La fecha mínima es ${dayjs(minimunDate).format("DD/MM/YYYY")}`}))
        changeDateFormat(field, minimunDate)
    }
}

function preselectPickDate(){
    if(!dataForm?.pickDate){
        changeDate("pickDate", minimunDate, true)
    }
}

function preselectStopDate(){
    if(!dataForm?.stopDate){
        changeDateTime("stopDate", minimunDate)
    }
}

function checkIfValidAfterClosingDateTime(component){
    const error = component.option("validationError")
    if(error){
        changeDateTime("stopDate",minimunDate)
        component.option("text", dayjs(minimunDate).format("DD/MM/YYYY, HH:mm"))
        component.option("value", minimunDate)
    }
}
function checkIfValidAfterClosingDate(component){
    const error = component.option("validationError")
    if(error){
        changeDate(dayjs(component.option("text"), "DD/MM/YYYY").toDate())
        component.option("text", dayjs(minimunDate).format("DD/MM/YYYY"))
        component.option("value", minimunDate)
    }
}

    return(
        <div className={classes.containers} id="documentation-request-form">
            <InputWrapper classes={classes} label={"Tipología"}>
              <SelectBox disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} height={25}></SelectBox>
            </InputWrapper>
            {type === TerminationsTemplateTypes.AAPP &&
            <>
             <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Código postal"}>
                        <TextBox key={"postalCode"} maxLength={10} name="postalCode" value={dataForm?.postalCode} onValueChanged={(e) => onChange("postalCode", e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Provincia"}>
                        <SelectBox disabled={provincesLoading === "loading" || !factoryActive} valueExpr={"description"} displayExpr="description"  key={"province"} name="province" value={dataForm?.province} className={classes.controlers} height={25} onValueChanged={(e) => { onChange("province", e.value)}} placeholder="" dataSource={provinces} ></SelectBox>
                    </InputWrapper>
                </div>
                <InputWrapper classes={classes} label={"Localidad"}>
                    <SelectBox disabled={!dataForm?.province || !factoryActive} searchEnabled placeholder="" key={"city"} valueExpr={"description"} displayExpr="description" name="city" value={dataForm?.city} onValueChanged={(e) => onChange("city",e.value)} className={classes.controlers} dataSource={{store: cities, paginate: true, pageSize: 20}} height={25} itemRender={(item)=><div className={classes.custom_item_factory}>{item.description}</div>}  ></SelectBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Dirección"}>
                    <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>           
                <InputWrapper classes={classes} label={"ITV en vigor"}>
                    <CheckBox key={"itvStatus"} name="itvStatus" value={dataForm?.itvStatus?dataForm?.itvStatus:false} onValueChanged={(e) => onChange("itvStatus", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Fecha de recogida"}>
                        <DateBox 
                            onOpened={()=>preselectPickDate()}
                            onClosed={(e)=>checkIfValidAfterClosingDateTime(e.component)}
                            min={minimunDate} 
                            applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"pickDate"} name="pickDate" type="date" 
                            value={dataForm?.pickDate ? dataForm?.pickDate : null} onValueChanged={(e) =>changeDateTime("pickDate", e.value)} className={classes.controlers} height={25}></DateBox>
                    </InputWrapper>   
                </div>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Nombre"}>
                        <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Apellidos"}>
                        <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Móvil"}>
                        <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>       
                    {!dataForm?.mtr &&   
                        <InputWrapper classes={classes} label={"Correo electrónico"}>
                            <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    }              
                </div>
            </>
            } 
        {(type === TerminationsTemplateTypes.RENTING_OWN_INSURANCE || type === TerminationsTemplateTypes.RENTING_OTHER_INSURANCE) &&       
        <div>
            <div className={classes.input_grid}>
                {type === TerminationsTemplateTypes.RENTING_OWN_INSURANCE &&
                <InputWrapper classes={classes} label={"Mtr"}>
                    <CheckBox key={"mtr"} name="mtr" value={dataForm?.mtr?dataForm?.mtr:false} onValueChanged={(e) => changeMtr(e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>             
                }
                {type === TerminationsTemplateTypes.RENTING_OWN_INSURANCE && dataForm?.mtr &&
                    <InputWrapper classes={classes} label={"Tipo"}>
                        <SelectBox value={dataForm?.mtrType} onValueChanged={(e) => onChange("mtrType",e.value)} placeholder="" dataSource={mtrTypes} height={25}></SelectBox>
                    </InputWrapper>
                }
            </div>
                {type === TerminationsTemplateTypes.RENTING_OWN_INSURANCE && dataForm?.mtr && dataForm?.mtrType == mtrTypes[0] &&
                    <InputWrapper classes={classes} label={"Matrícula a devolver"}>
                        <TextBox maxLength={50} key={"returnPlate"} name="returnPlate" value={dataForm?.returnPlate} onValueChanged={(e) => onChange("returnPlate", e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                }
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Código postal"}>
                        <TextBox key={"postalCode"} maxLength={10} name="postalCode" value={dataForm?.postalCode} onValueChanged={(e) => onChange("postalCode", e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Provincia"}>
                        {factoryActive?
                        <SelectBox disabled={provincesLoading === "loading" || !factoryActive} valueExpr={"description"} displayExpr="description"  key={"province"} name="province" value={dataForm?.province} className={classes.controlers} height={25} onValueChanged={(e) => { onChange("province", e.value)}} placeholder=""   dataSource={{store: provinces, paginate: true, pageSize: 20}}  ></SelectBox>
                        : <TextBox key={"province"} name="province" value={dataForm?.province} onValueChanged={(e) => onChange("province",e.value)} className={classes.controlers} height={25}></TextBox>
                        }
                    </InputWrapper>
                </div>
                <InputWrapper classes={classes} label={"Localidad"}>
                {factoryActive?
                    <SelectBox disabled={!dataForm?.province || !factoryActive || citiesLoading}  searchEnabled placeholder="" key={"city"} valueExpr={"description"} displayExpr="description" name="city" value={dataForm?.city} onValueChanged={(e) => onChange("city",e.value)} className={classes.controlers}   dataSource={{store: cities, paginate: true, pageSize: 20}}  height={25} itemRender={(item)=><div className={classes.custom_item_factory}>{item.description}</div>}  ></SelectBox>
                    : <TextBox key={"city"} name="city" value={dataForm?.city} onValueChanged={(e) => onChange("city",e.value)} className={classes.controlers} height={25}></TextBox>
                }
                </InputWrapper>
                {!dataForm?.mtr &&
                    <InputWrapper classes={classes} label={"Dirección"}>
                        <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                }
                {dataForm?.mtr && type === TerminationsTemplateTypes.RENTING_OWN_INSURANCE &&    
                    <div className={classes.input_grid}>
                        <InputWrapper classes={classes} label={"Calle"}>
                            <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                        <InputWrapper classes={classes} label={"Número"}>
                            <TextBox maxLength={10} key={"streetNumber"} name="streetNumber" value={dataForm?.streetNumber} onValueChanged={(e) => onChange("streetNumber",e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    </div>
                }
                {dataForm?.mtr&& type === TerminationsTemplateTypes.RENTING_OTHER_INSURANCE &&    
                    <div className={classes.input_grid}>
                        <InputWrapper classes={classes} label={"Fecha Parada Fact."}>
                            <DateBox 
                                onOpened={()=>preselectStopDate()}
                                onClosed={(e)=>checkIfValidAfterClosingDateTime(e.component)}
                                min={minimunDate} 
                                displayFormat={"dd/MM/yyyy HH:mm"} 
                                applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"stopDate"} name="stopDate" type="datetime" 
                                value={dataForm?.stopDate ? dataForm?.stopDate : null} onValueChanged={(e) =>changeDateTime("stopDate", e.value)} className={classes.controlers} height={25}></DateBox>
                        </InputWrapper>
                    </div>
                }
                {dataForm?.mtr&& type === TerminationsTemplateTypes.RENTING_OWN_INSURANCE &&    
                    <div className={classes.input_grid}>
                    {dataForm?.mtrType == mtrTypes[0] &&
                           <InputWrapper classes={classes} label={"Fecha Parada Fact."}>
                           <DateBox  
                                applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"pickDate"} name="pickDate" type="date" 
                                value={dataForm?.pickDate ? dataForm?.pickDate : null} onValueChanged={(e) =>changeDateTimeFormat("pickDate", e.value)} className={classes.controlers} height={25}></DateBox>
                        </InputWrapper>
                    }
                    {dataForm?.mtrType != mtrTypes[0] &&
                        <InputWrapper classes={classes} label={"Fecha Parada Fact."}>
                            <DateBox applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"stopDate"} name="stopDate" type="date" 
                                value={dataForm?.stopDate ? dataForm?.stopDate : null} onValueChanged={(e) =>changeDateTimeFormat("stopDate", e.value)} className={classes.controlers} height={25}></DateBox>
                        </InputWrapper>
                    }
                    </div>
                }
                    {!dataForm?.mtr&&   
                        <InputWrapper classes={classes} label={"ITV en vigor"}>
                                <CheckBox key={"itvStatus"} name="itvStatus" value={dataForm?.itvStatus?dataForm?.itvStatus:false} onValueChanged={(e) => onChange("itvStatus", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                            </InputWrapper>
                    }
                {!dataForm?.mtr &&   
                    <div className={classes.input_grid}>  
                        <InputWrapper classes={classes} label={"Fecha recogida"}>
                            <DateBox 
                                onOpened={()=>preselectPickDate()}
                                onClosed={(e)=>checkIfValidAfterClosingDate(e.component)}
                                min={minimunDate} 
                                applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"pickDate"} name="pickDate" type="date" 
                                value={dataForm?.pickDate ? dataForm?.pickDate : null} onValueChanged={(e) => changeDate("pickDate", e.value)} className={classes.controlers} height={25}></DateBox>
                        </InputWrapper>
                    </div>
                }
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Nombre"}>
                        <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Apellidos"}>
                        <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Móvil"}>
                        <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>       
                    {!dataForm?.mtr &&   
                        <InputWrapper classes={classes} label={"Correo electrónico"}>
                            <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    }              
                </div>
            </div>         
        }
        {(type === TerminationsTemplateTypes.VALUATION) &&  
            <>  
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Nombre"}>
                        <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Apellidos"}>
                        <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Móvil"}>
                        <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>                     
                    <InputWrapper classes={classes} label={"Correo electrónico"}>
                        <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>   
            </>
        }
        {(type === TerminationsTemplateTypes.VALUATION) && 
            <div className={classes.input_grid} style ={{marginBottom: "10px"}}>
                <InputWrapper classes={classes} label={"Km"}>
                    <TextBox key={"km"} maxLength={9} name="km" value={dataForm?.km} onValueChanged={(e) =>{ onChange("km",e.value)}} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>                     
            </div>   
        } 
        <InputWrapper classes={classes} label={"Notas"}>
            <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
        </InputWrapper>
        </div>
    )
}

export { TerminationsRequestForm }